'use strict';

/*globals services*/
/*globals blockElement*/
/*globals unBlockElement*/
/*globals initialize*/
/*globals isEmpty*/
/*globals invokeCallback*/
/*global updateButtonByPreparationStatus*/

function ProductionQueue(containerId, workplaceRID) {
  this.containerId = containerId;
  this.$container = null;
  this.$page = null;
  this.$body = null;
  this.$filterForm = null;
  this.$filterInputSearchByBarcode = null;
  this.$filterInputSearchByTradingPartner = null;
  this.$filterInputSearchInQueue = null;

  this.searchInQueueTimeout = null;
  this.searchByTradingPartnerTimeout = null;
  this.lastSearchedBarcode = null;
  this.lastSearchByTradingPartner = null;
  this.lastSearchInQueue = null;

  this.workplaceRID = workplaceRID;

  this.init();
}

ProductionQueue.prototype = $.extend({}, {
  constructor: 'ProductionQueue',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$body.on('click', '.process-operation', function () {
      _this.processOperation($(this).closest('tr'));

      return false;
    });

    _this.$body.on('click', '.production-queue__find-similar', function () {
      _this.findSimilar($(this));

      return false;
    });

    _this.$body.on('job-card-preparation-toggle', function (e, data) {
      _this.toggleJobCardPreparation(data);

      return false;
    });

    _this.$body.on('job-card-preparation-item-toggle', function (e, data) {
      _this.toggleJobCardPreparation(data);

      return false;
    });

    _this.$body.on('click', '.production-queue__transfer-note-new', function () {
      _this.createNewTransferNote();
      return false;
    });

    _this.$body.on('click', '.production-queue__timing-start', function () {
      _this.timingStart($(this));

      return false;
    });

    _this.$filterForm.on('change', 'input:radio', function () {
      _this.$filterForm.submit();
    });

    _this.$filterForm.on('keydown', 'input:text', function (e) {
      e = e || window.event;

      //do radku pro vyhledavani nacitaji cteckou, ktera to odnetruje - a to nechceme, proto to musime pohltit
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        $(this).change();

        e.preventDefault();
        return false;
      }
    });

    _this.$filterInputSearchByBarcode.on('change', function () {
      var $input = $(this);

      var value = $.trim($input.val());
      if (!isEmpty(value) && value !== _this.lastSearchedBarcode) {
        _this.lastSearchedBarcode = value;

        _this.changeBarcode($input, value);
      }
    });

    _this.$filterInputSearchByTradingPartner.on('keyup change', function () {
      var $input = $(this);

      if (_this.lastSearchByTradingPartner !== $input.val()) {
        clearTimeout(_this.searchByTradingPartnerTimeout);

        _this.searchByTradingPartnerTimeout = setTimeout(function () {
          _this.lastSearchByTradingPartner = $input.val();
          _this.searchInQueue($input.val());
        }, 350);
      }
    });

    _this.$filterInputSearchInQueue.on('keyup change', function () {
      var $input = $(this);

      if (_this.lastSearchInQueue !== $input.val()) {
        clearTimeout(_this.searchInQueueTimeout);

        _this.searchInQueueTimeout = setTimeout(function () {
          _this.lastSearchInQueue = $input.val();
          _this.searchInQueue($input.val());
        }, 350);
      }
    });

    services.get('key-shortcuts-manager').registerShortcut('confirm', function () {
      _this.openQueueItem(_this.$container.find('.table-fixed-hover-row'));
    });

    services.get('key-shortcuts-manager').registerShortcut('prev', function () {
      _this.setPrevRowHover();
    });

    services.get('key-shortcuts-manager').registerShortcut('next', function () {
      _this.setNextRowHover();
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  toggleRadio: function toggleRadio(name, value) {
    var _this = this;

    _this.$filterForm.find('[name*="' + name + '"]:checked').each(function () {
      var $radio = $(this);
      $radio.removeAttr('checked');
      $radio.closest('label').removeClass('active');
    });

    _this.$filterForm.find('[name*="' + name + '"][value="' + value + '"]').each(function () {
      var $radio = $(this);
      $radio.attr('checked', true);
      $radio.closest('label').addClass('active');
    });

    return _this;
  },

  changeBarcode: function changeBarcode($input, barcode) {
    var _this = this;

    services.get('barcode-check').checkBarcode(_this.$filterForm, _this.workplaceRID, barcode, _this.$filterForm.serialize(), function (barcodeType, data) {
      switch (barcodeType) {
        case 'Operation' : services.get('barcode-check').operationBarcode(barcode, data); break;
        case 'ContractCode' : {
          _this.$filterForm.find('[name*="ContractCodeRID"]').val(data.ContractCodeRID);

          //pokud hledam konkretni pruvodku, tak zmenim i nasledujici filtry
          _this.toggleRadio('ProductionDate', 'all');
          _this.toggleRadio('WorkshiftRID', 'all');

          _this.searchInQueue('', function () {
            var $rows = _this.$container.find('.operation-row');
            if ($rows.length === 1) {
              $rows.find('.process-operation').trigger('click');
            }
          });
        }

        break;
        case 'JobCard' : {
          _this.$filterForm.find('[name*="JobCardRID"]').val(data.JobCardRID);

          //pokud hledam konkretni pruvodku, tak zmenim i nasledujici filtry
          _this.toggleRadio('ProductionDate', 'all');
          _this.toggleRadio('WorkshiftRID', 'all');

          _this.searchInQueue('', function () {
            var $rows = _this.$container.find('.operation-row');
            if ($rows.length === 1) {
              $rows.find('.process-operation').trigger('click');
            }
          });
        } break;
      }

      $input.val('');
      $input.focus();
    });

    return _this;
  },

  timingStart: function timingStart($btn) {
    var _this = this;
    var JCOperationRID = $btn.data('jcoperation_rid');

    services.get('production-timing').start(JCOperationRID, function (timeStart) {
      var $stopwatch = $btn.closest('.production-queue__timing').find('.stopwatch');

      $btn.remove();

      $stopwatch.data('time_start', timeStart);
      $stopwatch.removeClass('stopwatch--paused');
      $stopwatch.show();
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  searchInQueue: function searchInQueue(value, callback) {
    var _this = this;

    var $wrapper = _this.$container.find('.production-queue__list');

    var data = _this.$filterForm.serializeObject();
    data.WorkplaceRID = _this.workplaceRID;

    blockElement($wrapper);
    $.get(services.get('router').path('production_queue_load', data), function (res) {
      unBlockElement($wrapper);

      $wrapper.html(res.data.html);
      initialize($wrapper);

      _this.setRowHover();

      invokeCallback(callback);
    });

    return _this;
  },

  findSimilar: function findSimilar($btn) {
    var _this = this;

    this.$filterForm.find('[name*="FindSimilar"]').val($btn.data('find_similar'));
    this.$filterForm.find('[name*="JobCardRID"]').val($btn.data('jobcard_rid'));
    this.$filterForm.find('[name*="JCOperationRID"]').val($btn.data('jcoperation_rid'));
    this.$filterForm.submit();

    return _this;
  },

  //----------------------------------------------------------------------------

  setRowHover: function setRowHover() {
    var _this = this;

    if (services.get('configurations').param('using_quick_functions')) {
      _this.$container.find('.table-fixed-hover-row').removeClass('table-fixed-hover-row');
      _this.$container.find('.process-operation__shortcut:visible:first').closest('tr').addClass('table-fixed-hover-row');
    }

    return _this;
  },

  setPrevRowHover: function setPrevRowHover() {
    var _this = this;

    if (services.get('configurations').param('using_quick_functions')) {
      var $actRow = _this.$container.find('.table-fixed-hover-row');
      var $prevRow = $actRow.prev('tr');
      if ($prevRow.length) {
        $actRow.removeClass('table-fixed-hover-row');
        $prevRow.addClass('table-fixed-hover-row');
      }
    }

    return _this;
  },

  setNextRowHover: function setNextRowHover() {
    var _this = this;

    if (services.get('configurations').param('using_quick_functions')) {
      var $actRow = _this.$container.find('.table-fixed-hover-row');
      var $nextRow = $actRow.next('tr');
      if ($nextRow.length) {
        $actRow.removeClass('table-fixed-hover-row');
        $nextRow.addClass('table-fixed-hover-row');
      }
    }

    return _this;
  },

  openQueueItem: function openQueueItem($row) {
    // pokud mam jeden radek, tak ho otevru
    if ($row.length === 1) {
      // presmeruji na danou stranku
      location.href = $row.find('.btn').attr('href');

      return true;
    } else {
      alert(services.get('translator').trans('production_queue.no_selected_operation'));
    }

    return false;
  },

  //----------------------------------------------------------------------------

  processOperation: function processOperation($row) {
    var _this = this;

    location.href = $row.find('.process-operation').attr('href');

    return _this;
  },

  //----------------------------------------------------------------------------

  toggleJobCardPreparation: function toggleJobCardPreparation(data) {
    var _this = this;

    var $btn = _this.$container.find('.job-card__toggle-preparation[data-jobcard_rid="' + data.JobCardRID + '"][data-jcoperation_rid="' + data.JCOperationRID + '"]');

    updateButtonByPreparationStatus($btn, data.JobCardPreparationStatus);

    return _this;
  },

  createNewTransferNote: function createNewTransferNote() {
    var _this = this;

    services.get('article').find(function (id) {
      services.get('transfer-note').create(id, 'new');
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container =  $('#' + _this.containerId);
    _this.$page = $('html');
    _this.$body = $('body');
    _this.$filterForm = _this.$container.find('#production-queue__filter-form');
    _this.$filterInputSearchByBarcode = _this.$filterForm.find('.production-queue__input-search-by-barcode');
    _this.$filterInputSearchByTradingPartner = _this.$filterForm.find('.production-queue__input-search-by-trading-partner');
    _this.$filterInputSearchInQueue = _this.$filterForm.find('.production-queue__input-search-in-queue');

    _this.registerCallbacks();

    _this.$filterInputSearchByBarcode.focus();
    _this.setRowHover();

    return _this;
  }
});
